import { alertConstants } from "./alert.constants";
import { store } from "./store";

export const alertActions = {
    // clear,
    // generalError,
    // generalSuccess,
    generalErrorAndClear,
    generalSuccessAndClear,
};

function clear() {
    return { type: alertConstants.CLEAR };
}

function generalSuccessAndClear(message, duration) {
    if (duration) {
        setTimeout(() => {
            store.dispatch(clear());
        }, duration);
    }
    return generalSuccess(message);
}

function generalErrorAndClear(message, duration) {
    if (duration) {
        setTimeout(() => {
            store.dispatch(clear());
        }, duration);
    }
    return generalError(message);
}

function generalSuccess(message) {
    return { type: alertConstants.GENERAL_SUCCESS, message };
}

function generalError(message) {
    return { type: alertConstants.GENERAL_ERROR, message };
}
